// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "loyaltyConnect__agreementCheckboxWrapper-2u3-J";
export { _1 as "__esModule", _2 as "loyaltyConnect__agreementCheckboxWrapper" }
export default { "__esModule": _1, "loyaltyConnect__agreementCheckboxWrapper": _2 }
